import { render, staticRenderFns } from "./AppointmentList.vue?vue&type=template&id=b71d06c8&scoped=true"
import script from "./AppointmentList.vue?vue&type=script&lang=ts"
export * from "./AppointmentList.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentList.vue?vue&type=style&index=0&id=b71d06c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71d06c8",
  null
  
)

export default component.exports